import { BrowserRouter } from "react-router-dom";
import { AuthProvider }      from "./contexts/AuthContext";
import { ThemeProvider }     from "./contexts/ThemeContext";
import { ThemePreviewProvider } from "./contexts/ThemePreviewContext";
import { ToastProvider }     from "./contexts/ToastContext";
import { UserStatsProvider } from "./contexts/UserStatsContext";
import { ListsProvider }     from "./contexts/ListsContext";
import { UserBooksProvider } from "./contexts/UserBooksContext";
import { BlocksProvider }    from "./contexts/BlocksContext";
import { AppRoutes }         from "./routes/AppRoutes";
import { FcmTokenSync }      from "./features/notifications/components/FcmTokenSync";
import { NativePushTapNavigator } from "./features/notifications/components/NativePushTapNavigator";
import { NativeBackButtonBridge } from "./components/layout/NativeBackButtonBridge";
import { FirestoreResumeWatcher } from "./components/layout/FirestoreResumeWatcher";
import { RevenueCatSync }    from "./features/pro/components/RevenueCatSync";
import { FirstShelfAddNotice } from "./features/books/components/FirstShelfAddNotice";
import { ThemePreviewBar } from "./components/theme/ThemePreviewBar";
import "./styles/index.css";

function App() {
  return (
    <AuthProvider>
      {/* Acima do ThemeProvider: é ele que decide se o tema exibido vem do
          perfil ou de um test-drive da loja. */}
      <ThemePreviewProvider>
      <ThemeProvider>
        <BrowserRouter>
          <ToastProvider>
            <UserStatsProvider>
              <ListsProvider>
                <UserBooksProvider>
                  {/* Lista de bloqueios (moderação de UGC). Dentro do
                      UserBooksProvider porque as superfícies que filtram
                      (feed, resenhas) vivem abaixo daqui, e o custo é 1
                      leitura por sessão. */}
                  <BlocksProvider>
                  <AppRoutes />
                  {/* Aviso único de 1ª adição à estante. Mora aqui, e não nas
                      superfícies que adicionam, porque todas elas desmontam
                      logo após salvar. */}
                  <FirstShelfAddNotice />
                  {/* Saída (e conversão) do preview de tema. Global porque o
                      preview vale o app inteiro — some sozinha sem preview. */}
                  <ThemePreviewBar />
                  {/* Re-registro silencioso do FCM token pra quem já optou
                      por push — sem ele o token rotaciona e o push morre em
                      silêncio. Nunca pede permissão (isso é do toggle em
                      Settings). */}
                  <FcmTokenSync />
                  {/* Toque em push no app NATIVO → navega pro data.url do
                      payload (na web quem faz isso é o service worker). Web:
                      no-op puro, sem listener e sem plugin. */}
                  <NativePushTapNavigator />
                  {/* Botão/gesto de voltar do Android: história interna volta
                      página, raiz sai do app (sem listener, o plugin engolia
                      o evento na raiz — BUG-172). Web/iOS: no-op. */}
                  <NativeBackButtonBridge />
                  {/* App volta do background e o Firestore nao volta: a
                      AsyncQueue e serial, entao uma transacao de IndexedDB
                      morta na suspensao trava TODA leitura pelo resto da
                      vida do documento (tela cheia de dados, nada carrega).
                      Sonda de custo zero na retomada e, se estiver morta,
                      recarrega — o unico caminho que nao passa pela fila. */}
                  <FirestoreResumeWatcher />
                  {/* Alinha o appUserID do RevenueCat ao uid do Firebase no
                      build nativo. NÃO mostra nem compra nada — a vitrine
                      segue atrás de purchaseAvailability. Na web sai no
                      guard de plataforma sem carregar o plugin. */}
                  <RevenueCatSync />
                  </BlocksProvider>
                </UserBooksProvider>
              </ListsProvider>
            </UserStatsProvider>
          </ToastProvider>
        </BrowserRouter>
      </ThemeProvider>
      </ThemePreviewProvider>
    </AuthProvider>
  );
}

export default App;
